import { EditableRowRef } from '@/components';
import { useRef } from 'react';

export const useEditableRowRef = () => {
	const rowRefs = useRef<{ [key: string]: React.RefObject<EditableRowRef> }>(
		{}
	);

	return rowRefs;
};
